import { useContext, useState } from 'react'

import { ExitToApp } from '@material-ui/icons'
import { EditContext } from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ComplexDialog from 'Components/UI/Molecules/ComplexDialog'
import ComplexDialogActions from 'Components/UI/Molecules/ComplexDialog/Actions'
import ComplexDialogHistory from 'Components/UI/Molecules/ComplexDialogHistory'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import Asientos from './Asientos'
import Comprobantes from './Comprobantes'
import HomeContent from './Home'
import PaymentMethods from './PaymentMethods'

const Edit = (props) => {
  const { open, handleclose, data, setRender, render, setLoading, dataBefore, permissions } = props

  const createDismissableSnackbar = useCustomSnackbar()

  const { state, setOpen, setClose } = SetState()
  const [edit] = useContext(EditContext)

  const [dataInfo, setDataInfo] = useState(data)

  const handleChange = (newData) => {
    setDataInfo((prevDataInfo) => ({
      ...prevDataInfo,
      receiptDetails: newData,
    }))
  }

  const origenLabel = SUCURSAL_ORIGEN.find(
    (sucursal) => sucursal.label === data.receipt.origen.toUpperCase()
  )
  const empresaId = origenLabel ? origenLabel.id : null

  const handleDelete = async () => {
    setLoading(true)
    await interfaces.salesReceipt
      .deleteReceipt(data.receipt.id, empresaId)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRender(!render)
        handleclose()
      })
      .catch((err) => {
        createDismissableSnackbar(err.response.data.data, {
          variant: 'error',
        })
      })
    setLoading(false)
    setClose()
  }

  const getFlatChanges = (original, updated) => {
    let diff = {}

    const compare = (obj1, obj2) => {
      Object.keys(obj2).forEach((key) => {
        if (key === 'history' || key === 'asientos' || key === 'receiptDetail') return

        if (typeof obj2[key] === 'object' && obj2[key] !== null && !Array.isArray(obj2[key])) {
          compare(obj1[key] || {}, obj2[key])
        } else if (String(obj2[key] ?? '') !== String(obj1[key] ?? '')) {
          diff[key] = obj2[key]
        }
      })
    }

    compare(original, updated)
    return diff
  }

  const handleSubmit = async () => {
    const body = getFlatChanges(data.receipt, dataInfo.receipt)

    const numChanges = Object.keys(body).length
    if (numChanges === 0) {
      return createDismissableSnackbar('No hay cambios para guardar', {
        variant: 'info',
      })
    }

    if (numChanges === 1 && body.hasOwnProperty('total')) {
      createDismissableSnackbar('Cambios guardados correctamente', {
        variant: 'success',
      })
      setRender(!render)
      handleclose()
      return
    }

    if (body.total) delete body.total

    setLoading(true)

    await interfaces.salesReceipt.edit(data.receipt.id, empresaId, body).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      handleclose()
      setRender(!render)
    })
    setLoading(false)
  }

  const horizontalTabs = [
    {
      id: 0,
      title: 'Inicio',
      color: 'primary',
    },
    {
      id: 1,
      title: 'Medio de pago',
      color: 'primary',
    },
    {
      id: 2,
      title: 'Comprobantes',
      color: 'primary',
    },
    {
      id: 3,
      title: 'Asientos',
      color: 'primary',
    },
    {
      id: 4,
      title: 'Historial',
      color: 'primary',
    },
  ]

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <HomeContent
            data={dataInfo}
            setData={setDataInfo}
            permissions={permissions}
            setLoading={setLoading}
            empresaId={empresaId}
            handleclose={handleclose}
            setRender={setRender}
            render={render}
          />
        )
      case 1:
        return (
          <PaymentMethods
            data={dataInfo}
            onDataChange={handleChange}
            edit={edit}
            setRender={setRender}
            render={render}
            dataBefore={dataBefore}
            setData={setDataInfo}
            empresaId={empresaId}
          />
        )

      case 2:
        return <Comprobantes data={dataInfo} />
      case 3:
        return <Asientos data={dataInfo} edit={edit} dataBefore={dataBefore} />
      case 4:
        return (
          <div style={{ height: '552px', overflow: 'auto' }}>
            <ComplexDialogHistory history={dataInfo.history} disableScroll />
          </div>
        )
      default:
        break
    }
  }

  return (
    <>
      <ComplexDialog
        open={open}
        onClose={handleclose}
        tabs={horizontalTabs}
        title={`Recibo ${data.receipt.id}`}
        subtitle={
          <div>
            {`Creado el ${new Date(dataInfo.receipt.fecha).toLocaleDateString('es-AR')} por ${dataInfo.receipt.usuario}`}
          </div>
        }
        children={renderTabs}
        actions={
          <ComplexDialogActions
            onClose={handleclose}
            handleSubmit={() => handleSubmit()}
            canEdit={!permissions.edit}
            data={dataInfo}
            editMode={true}
            leftButton={{
              icon: <ExitToApp fontSize="small" />,
              title: 'Eliminar',
              variant: 'contained',
              disabled: dataInfo.receipt.estado === 'Borrador' ? !edit : true,
              style: {
                background: dataInfo.receipt.estado === 'Borrador' ? 'rgb(244, 67, 54)' : '#e0e0e0',
                color: dataInfo.receipt.estado === 'Borrador' ? '#fff' : '#adadad',
              },
              onClick: () => {
                setOpen()
              },
            }}
          />
        }
      />

      {state.suspense && (
        <DialogComponent
          open={state.open}
          handleclose={state.loading ? null : setClose}
          widthLarge={500}
          title="¿Desea eliminar el siguiente recibo?"
          subtitle="¡Esta acción es irreversible!"
          disableChildHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons
              onClickSubmit={() => handleDelete()}
              disabledCancel={state.loading}
              disabledSubmit={state.loading}
              isLoading={state.loading}
            />
          }
        />
      )}
    </>
  )
}

export default Edit
